import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import InputMask from "react-input-mask";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { resolveCountryInputConfig, useCurrencySymbol } from "../../../utils/currencyUtils";
import DateConversion from "../../../utils/DateConversion";
import CommaConvert from "../../../utils/CommaConvert";
import { resetcurrentLeadID, setcurrentLeadID, setCurrentPageTitle } from "../../../store/slices/pageSlice";
import { addLead, fetchLeads, updateLead } from "../../../store/slices/leadsSlice";
import {
  isWonLeadStatusValue,
  withDirectWonCommentMarker,
} from "../../../utils/isDirectWonLead";
import { fetchCompanyProfiles } from "../../../store/slices/companyProfileSlice";
import { fetchEmployees } from "../../../store/slices/employeeAdminSlice";
import { fetchLeadTypes } from "../../../store/slices/leadTypeSlice";
import { fetchGroups } from "../../../store/slices/groupSlice";
import { fetchSources } from "../../../store/slices/sourceSlice";
import { fetchStatus } from "../../../store/slices/statusSlice";
import { fetchServiceTypes } from "../../../store/slices/serviceTypesSlice";
import AdminLoader from "../../../components/common/loader/AdminLoader";
import { fetchEmployeeGroups } from "../../../store/slices/employeeGroup";
import { goNext, setCreatedProject } from "../../../store/slices/WizardSlice/wizardStepSlice";
import { setShowWizard } from "../../../store/slices/WizardSlice/WizardSlice";
import { deleteLeadId, generateLeadId } from "../../../store/slices/lead/leadIdGenerationSlice";
import FileUploadAddLead from "../../lead/FileUploadAddLead";
import { uploadFile } from "../../../store/slices/FileDataSlice";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import { fetchSalesHourlyRates } from "../../../store/slices/salesHourlyRateSlice";
import { updateProjectQuotedStatusThunk } from "../../../store/slices/projectQuoteSlice";
import { buildProjectsDetailsPayloadForLeadEdit } from "../../../utils/buildProjectsDetailsForUpdateLockQuoted";
import { fetchOtherExpenses } from "../../../store/slices/otherexpenses";
import {
    getLoggedSalesUserId,
    getPerdiemAndAverageCostFromExpenses,
    scopeOtherExpensesForUser,
} from "../../../utils/salespersonRatesScope";
import { useLoggedUser } from "../../../utils/useLoggedUser";

const AddProject = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const currency = useCurrencySymbol();
    const { getDatePlaceholder, getDateFormat } = DateConversion();
    const USAComma = CommaConvert();
    const dispatch = useDispatch();
    const name = localStorage.getItem("name");
    const lastName = localStorage.getItem("lastName");
    const email = localStorage.getItem("email");
    const [AssignedPeople, SetAssignedPeople] = useState([]);
    const [Category] = useState("");
    const createdProject = useSelector((state) => state.wizardstep.createdProject);
    const step = useSelector((state) => state.wizardstep.step);
    const employeeslist = useSelector((state) => state.employees.employees);
    const { leads } = useSelector((state) => state.leads);
    const { employees } = useSelector((state) => state.employees);
    const { group } = useSelector((state) => state.group);
    const { serviceTypesRedux } = useSelector((state) => state.serviceTypesRedux);
    const { source } = useSelector((state) => state.source);
    const { leadTypesRedux } = useSelector((state) => state.leadTypesRedux);
    const { status } = useSelector((state) => state.status);
    const currentLeadID = useSelector((state) => state.page.currentLeadID);
    const { projects } = useSelector((state) => state.projects);
    const { profiles } = useSelector((state) => state.companyProfile);
    const { data: salesHourlyRateData } = useSelector((state) => state.salesHourlyRate);
    const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
    const loggedInUserId = useSelector((state) => state.leads.loggedInUserId);
    const [hasForwardedManagers, setHasForwardedManagers] = useState(false);

    const loggedEmployee = useLoggedUser();
    const { iso2: defaultCountry, onlyCountries: allowedCountries } =
        resolveCountryInputConfig({
            countrycode: loggedEmployee?.countrycode,
            region: loggedEmployee?.region,
        });
    console.log("wizard1 allowedCountries:", allowedCountries, defaultCountry);

    useEffect(() => {
        dispatch(setCurrentPageTitle("Add Project"));
        dispatch(fetchLeads());
        dispatch(fetchCompanyProfiles());
        dispatch(fetchEmployees());
        dispatch(fetchServiceTypes());
        dispatch(fetchLeadTypes());
        dispatch(fetchGroups());
        dispatch(fetchSources());
        dispatch(fetchStatus());
        dispatch(fetchEmployees());
        dispatch(fetchEmployeeGroups());
        dispatch(fetchAllProjects());
        dispatch(fetchOtherExpenses());
        dispatch(fetchSalesHourlyRates());
    }, [dispatch]);

    const [LeadDate, setLeadDate] = useState(() => new Date());
    const [FollowupDate, setFollowupDate] = useState(null);

    const parseTypedDate = (value, format) => {
        if (!value) return null;
        const normalizedValue = value.replace(/\//g, "-");
        const normalizedFormat = String(format || "").replace(/\//g, "-").toLowerCase();
        let day, month, year;
        if (normalizedFormat === "mm-dd-yyyy") {
            [month, day, year] = normalizedValue.split("-");
        } else if (normalizedFormat === "dd-mm-yyyy") {
            [day, month, year] = normalizedValue.split("-");
        } else {
            return null;
        }
        const parsed = new Date(year, month - 1, day);
        return isNaN(parsed) ? null : parsed;
    };

    const [isLoading, SetisLoading] = useState(false);
    const [GroupNames, setGroupNames] = useState([]);
    const [Sources, setSources] = useState([]);
    const [LeadTypes, setLeadTypes] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [ClientName, setClientName] = useState("");
    const [TypeService, setSelectedServices] = useState([]);
    const [LeadType, setLeadType] = useState("");
    const [AssignedGroup, setAssignedGroup] = useState("");
    const [selectedGroupId, setSelectedGroupId] = useState("");
    const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
    const [QuotedValue, setQuotedValue] = useState("");
    const [ProjectName, setProjectName] = useState("");
    const [Reference, setReference] = useState("");
    const [ClientPhone, setClientPhone] = useState("");
    const [ClientContactName, setClientContactName] = useState("");
    const [ClientEmail, setClientEmail] = useState("");
    const [Status, setStatus] = useState("");
    const [Source, setSource] = useState("");
    const [Probability, setProbability] = useState("");
    const [comments, setComments] = useState("");
    const [showSourceDropdown, setShowSourceDropdown] = useState("");
    const [showGroupDropdown, setShowGroupDropdown] = useState("");
    const [showServiceDropdown, setShowServiceDropdown] = useState(false);
    const [showLeadTypeDropdown, setShowLeadTypeDropdown] = useState("");
    const [showStatusDropdown, setShowStatusDropdown] = useState("");
    const [showProbabilityDropdown, setShowProbabilityDropdown] = useState("");
    const [SelectedCategory, setSelectedCategory] = useState("");
    const [fileNames, setFileNames] = useState([]);
    const dropdownRefSource = useRef(null);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [quotationId, setQuotationId] = useState("");
    const quotationIdRef = useRef(quotationId);
    const firstLettersRef = useRef({ group: "", clientName: "", projectName: "" });

    useEffect(() => {
        quotationIdRef.current = quotationId;
    }, [quotationId]);

    const handleSendLeadID = useCallback(async (forceRegenerate = false) => {
        // Extract first letters only
        const firstLetterGroup = AssignedGroup ? AssignedGroup.trim().charAt(0).toUpperCase() : "";
        const firstLetterClient = ClientName ? ClientName.trim().charAt(0).toUpperCase() : "";
        const firstLetterProject = ProjectName ? ProjectName.trim().charAt(0).toUpperCase() : "";

        // Only proceed if all three fields have at least one character
        if (!firstLetterGroup || !firstLetterClient || !firstLetterProject) return;

        const currentQuotationId = quotationIdRef.current;
        const currentFirstLetters = firstLettersRef.current;

        // Check if first letters have changed
        const firstLettersChanged =
            currentFirstLetters.group !== firstLetterGroup ||
            currentFirstLetters.clientName !== firstLetterClient ||
            currentFirstLetters.projectName !== firstLetterProject;

        // If first letters haven't changed and we already have an ID, don't call API
        if (!forceRegenerate && !firstLettersChanged && currentQuotationId && currentQuotationId.length > 5) {
            return;
        }

        try {
            // Delete old ID if it exists and first letters changed
            if (firstLettersChanged && currentQuotationId && currentQuotationId.length > 5) {
                try {
                    await dispatch(
                        deleteLeadId({
                            generatedLeadId: currentQuotationId,
                        })
                    ).unwrap();
                } catch (error) {
                    console.error("Delete Lead ID failed", error);
                }
                setQuotationId("");
                quotationIdRef.current = "";
            }

            // Update the first letters ref
            firstLettersRef.current = {
                group: firstLetterGroup,
                clientName: firstLetterClient,
                projectName: firstLetterProject,
            };

            // Call API with only first letters
            const response = await dispatch(
                generateLeadId({
                    group: firstLetterGroup,
                    clientName: firstLetterClient,
                    projectName: firstLetterProject,
                })
            ).unwrap();
            setQuotationId(response.quotationId);
            quotationIdRef.current = response.quotationId;
        } catch (error) {
            console.error("Generate Lead ID failed", error);
        }
    }, [AssignedGroup, ClientName, ProjectName, dispatch]);

    const projectNameRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                projectNameRef.current &&
                !projectNameRef.current.contains(event.target) &&
                AssignedGroup &&
                ClientName &&
                ProjectName
            ) {
                handleSendLeadID();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [AssignedGroup, ClientName, ProjectName, handleSendLeadID]);

    useEffect(() => {
        // Extract first letters only
        const firstLetterGroup = AssignedGroup ? AssignedGroup.trim().charAt(0).toUpperCase() : "";
        const firstLetterClient = ClientName ? ClientName.trim().charAt(0).toUpperCase() : "";
        const firstLetterProject = ProjectName ? ProjectName.trim().charAt(0).toUpperCase() : "";

        // Only proceed if all three fields have at least one character
        if (!firstLetterGroup || !firstLetterClient || !firstLetterProject) return;

        const currentFirstLetters = firstLettersRef.current;

        // Check if first letters have changed
        const firstLettersChanged =
            currentFirstLetters.group !== firstLetterGroup ||
            currentFirstLetters.clientName !== firstLetterClient ||
            currentFirstLetters.projectName !== firstLetterProject;

        // Only call API if first letters have changed
        if (firstLettersChanged) {
            handleSendLeadID(true);
        }
    }, [AssignedGroup, ClientName, ProjectName, handleSendLeadID]);

    const leadIdDeleteRef = useRef(null);

    const handleDeleteLeadID = useCallback(async () => {
        if (!quotationId) return;

        try {
            dispatch(
                deleteLeadId({
                    generatedLeadId: quotationId,
                })
            );
            setQuotationId("");
        } catch (error) {
            console.error("Generate Lead ID failed", error);
        }
    }, [dispatch, quotationId]);

    useEffect(() => {
        if (quotationId || currentLeadID) {
            if ((!ClientName && !ProjectName) || !ProjectName) {
                handleDeleteLeadID()
                dispatch(setcurrentLeadID(""));
            }
        }
    }, [quotationId, ClientName, ProjectName, currentLeadID, dispatch, handleDeleteLeadID])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                leadIdDeleteRef.current &&
                !leadIdDeleteRef.current.contains(event.target)
            ) {
                handleDeleteLeadID();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleDeleteLeadID]);

    useEffect(() => {
        if (quotationId) {
            dispatch(setcurrentLeadID(quotationId));
        }
    }, [dispatch, quotationId]);

    console.log("wizard1 ClientPhone", ClientPhone)

    useEffect(() => {
        if (createdProject?.length > 0) {
            console.log("wizard1 useEffect createdProject", createdProject)
            setClientContactName(createdProject?.[0]?.ClientContactName)
            setClientEmail(createdProject?.[0]?.ClientEmail)

            // setClientPhone(String(createdProject?.[0]?.ClientPhone));
            const phoneStr = String(createdProject?.[0]?.ClientPhone || "");
            const lastTenDigits = phoneStr.slice(-10);
            if (loggedEmployee?.countrycode === "+1") {
                setClientPhone("1" + lastTenDigits);
            } else if (loggedEmployee?.countrycode === "+91") {
                setClientPhone("91" + lastTenDigits);
            } else {
                setClientPhone(lastTenDigits);
            }

            setClientPhone(phoneStr);

            setLeadDate(createdProject?.[0]?.LeadDate)
            const createdGroupId = createdProject?.[0]?.groupid?._id || createdProject?.[0]?.groupid || "";
            const createdGroupName = group.find((g) => String(g?._id || g?.id) === String(createdGroupId))?.newGroupName || createdProject?.[0]?.AssignedGroup || "";
            setAssignedGroup(createdGroupName)
            setSelectedGroupId(createdGroupId ? String(createdGroupId) : "")
            setClientName(createdProject?.[0]?.ClientName)
            setProjectName(createdProject?.[0]?.ProjectName)
            setSelectedServices(createdProject?.[0]?.TypeService)
            setSelectedServiceTypes(createdProject?.[0]?.TypeService)
            setQuotedValue(createdProject?.[0]?.QuotedValue)
            setSource(createdProject?.[0]?.Source)
            setStatus(createdProject?.[0]?.Status)
            setReference(createdProject?.[0]?.Reference)
            setLeadType(createdProject?.[0]?.LeadType)
            setProbability(createdProject?.[0]?.Probability)
            setFollowupDate(createdProject?.[0]?.FollowupDate)
            setComments(createdProject?.[0]?.comments)
            const restoredQuotationId = createdProject?.[0]?.quotationId;
            if (restoredQuotationId) {
                setQuotationId(restoredQuotationId);
                quotationIdRef.current = restoredQuotationId;
                const firstLetterGroup = createdGroupName
                    ? createdGroupName.trim().charAt(0).toUpperCase()
                    : "";
                const firstLetterClient = createdProject?.[0]?.ClientName
                    ? String(createdProject[0].ClientName).trim().charAt(0).toUpperCase()
                    : "";
                const firstLetterProject = createdProject?.[0]?.ProjectName
                    ? String(createdProject[0].ProjectName).trim().charAt(0).toUpperCase()
                    : "";
                firstLettersRef.current = {
                    group: firstLetterGroup,
                    clientName: firstLetterClient,
                    projectName: firstLetterProject,
                };
            }
            dispatch(setcurrentLeadID(createdProject?.[0]?.quotationId));

        }
    }, [createdProject, dispatch, loggedEmployee, group])

    // Check if managers have been forwarded for the current quotationId
    useEffect(() => {
        if (createdProject?.length > 0 && projects?.length > 0) {
            const currentQuotationId = createdProject[0]?.quotationId;
            if (currentQuotationId) {
                // Check if there are projects with AssignedManagerEmail for this quotationId
                const matchingProjects = projects.filter(
                    (project) => 
                        project.quotationId === currentQuotationId &&
                        project.AssignedManagerEmail &&
                        project.AssignedManagerEmail.length > 0
                );
                
                // Set hasForwardedManagers to true if any project has managers assigned
                setHasForwardedManagers(matchingProjects.length > 0);
            } else {
                setHasForwardedManagers(false);
            }
        } else {
            setHasForwardedManagers(false);
        }
    }, [createdProject, projects]);

    useEffect(() => {
        setGroupNames(group);
        setSources(source);
        setLeadTypes(leadTypesRedux);
        setStatuses(status);
    }, [employees, group, serviceTypesRedux, source, leadTypesRedux, status, leads, employeeslist]);

    useEffect(() => {
        if (AssignedGroup && !selectedGroupId) {
            const matched = (group || []).find((g) => g?.newGroupName === AssignedGroup);
            if (matched?._id || matched?.id) {
                setSelectedGroupId(matched?._id || matched?.id);
            }
        }
    }, [AssignedGroup, selectedGroupId, group]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefSource.current &&
                !dropdownRefSource.current.contains(event.target)
            ) {
                setShowSourceDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dropdownRefGroup = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefGroup.current &&
                !dropdownRefGroup.current.contains(event.target)
            ) {
                setShowGroupDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dropdownRefService = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefService.current &&
                !dropdownRefService.current.contains(event.target)
            ) {
                setShowServiceDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dropdownRefLeadType = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefLeadType.current &&
                !dropdownRefLeadType.current.contains(event.target)
            ) {
                setShowLeadTypeDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dropdownRefStatus = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefStatus.current &&
                !dropdownRefStatus.current.contains(event.target)
            ) {
                setShowStatusDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dropdownRefProbability = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefProbability.current &&
                !dropdownRefProbability.current.contains(event.target)
            ) {
                setShowProbabilityDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (LeadDate && LeadDate > new Date()) {
            enqueueSnackbar("Future dates are not allowed in Lead Date", {
                variant: "error",
            });
            setLeadDate(null);
        }
    }, [LeadDate, enqueueSnackbar]);

    useEffect(() => {
        if (FollowupDate && LeadDate) {
            const lead = new Date(LeadDate);
            const followup = new Date(FollowupDate);

            if (followup < lead) {
                enqueueSnackbar("Followup date must be after lead date.", {
                    variant: "error",
                });
                setFollowupDate(null);
            }
        }
    }, [FollowupDate, LeadDate, enqueueSnackbar]);

    const handleSourceChange = (source) => {
        const value = source;
        setSource(value);
        setShowSourceDropdown(false);
    };

    const handleGroupChange = (Group) => {
        const value = Group;
        setAssignedGroup(value);
        const matched = (group || []).find((g) => g?.newGroupName === value);
        setSelectedGroupId(matched?._id || matched?.id || "");
        setShowGroupDropdown(false);
    };

    const handleServiceChange = (service) => {
        setSelectedServices((prevSelected) => {
            if (prevSelected.includes(service)) {
                // Unselect if already selected
                return prevSelected.filter((s) => s !== service);
            } else {
                // Select if not selected
                return [...prevSelected, service];
            }
        });
    };

    const handleLeadTypeChange = (Leadtype) => {
        const value = Leadtype;
        setLeadType(value);
        setShowLeadTypeDropdown(false);
    };

    const handleStatusChange = (status) => {
        const value = status;
        setStatus(value);
        setFollowupDate(null)
        setShowStatusDropdown(false);
        if (value !== "Pending") {
            setProbability("");
        }
    };

    const handleProbabilityChange = (Probability) => {
        const value = Probability;
        setProbability(value);
        setShowProbabilityDropdown(false);
    };

    const LeadOwner = name + " " + lastName;
    const LeadOwnerEmail = email;

    const isValid =
        ClientName &&
        ProjectName &&
        Status && (Status !== "Pending" || Probability) &&
        (Status === "Won" || Status === "Lost" || FollowupDate) &&
        LeadDate &&
        Source &&
        ClientPhone &&
        (
            (loggedEmployee?.countrycode === "+1" && ClientPhone.length === 11) ||
            (loggedEmployee?.countrycode === "+91" && ClientPhone.length === 12)
        )
        &&        // ClientPhone?.length === 10 &&
        LeadType &&
        ClientContactName &&
        ClientEmail &&
        TypeService?.length > 0 &&
        QuotedValue;


    const Submit = async () => {
        if (
            !ClientName ||
            !ProjectName ||
            (Status !== "Won" && Status !== "Lost" && !FollowupDate) ||
            (Status === "Pending" &&
                !["High", "Medium", "Low"].includes(Probability)) ||
            !LeadType ||
            !LeadDate ||
            !Source ||
            !ClientPhone ||
            !ClientContactName ||
            !ClientEmail ||
            !TypeService?.length ||
            !Status ||
            !QuotedValue
        ) {
            enqueueSnackbar("Please fill all the fields!", {
                variant: "error",
            });
            return;
        }
        const lastTenDigits = ClientPhone?.slice(-10);
        if (/^0{10}$/.test(lastTenDigits)) {
            enqueueSnackbar("Enter Valid Phone Number!", {
                variant: "error",
            });
            return;
        }
        const numericPhone = ClientPhone.replace(/\D/g, ""); // Removes non-numeric characters
        if (numericPhone?.length < 10) {
            enqueueSnackbar("Phone number must be at least 10 digits!", {
                variant: "error",
            });
            return;
        }

        if (!emailRegex.test(ClientEmail)) {
            enqueueSnackbar("Please enter a valid email address!", {
                variant: "error",
            });
            return;
        }

        if (Source === "Reference" && !Reference) {
            enqueueSnackbar("Please enter Reference!", {
                variant: "error",
            });
            return;
        }

        SetisLoading(true);
        try {
            const newLead = {
                ClientName,
                ClientEmail,
                ProjectName,
                LeadDate,
                ClientPhone,
                QuotedValue,
                ClientContactName,
                Status,
                Source,
                TypeService,
                AssignedGroup,
                groupid: selectedGroupId || undefined,
                LeadType,
                FollowupDate,
                Probability,
                Reference,
                comments: isWonLeadStatusValue(Status)
                  ? withDirectWonCommentMarker(comments)
                  : comments,
                AssignedPeople,
                LeadOwner,
                LeadOwnerEmail,
                quotationId: quotationId,
                SalesPersonStatus: "project requested",
                ...(isWonLeadStatusValue(Status) ? { isDirectWon: true } : {}),
            };
            const response = await dispatch(addLead(newLead)).unwrap();
            enqueueSnackbar("Lead Added Successfully!", {
                variant: "success",
            });
            const data = response.lead; // Directly accessing the lead object
            if (isWonLeadStatusValue(Status) && (data?._id || data?.id)) {
                try {
                    await dispatch(
                        updateLead({
                            id: data.id || data._id,
                            updatedData: {
                                isDirectWon: true,
                                comments: withDirectWonCommentMarker(data.comments || comments || ""),
                                quotationId: data.quotationId || quotationId,
                                Status,
                            },
                        })
                    ).unwrap();
                } catch (_) {
                    // non-blocking
                }
            }
            await handleFileUpload(data._id); // Upload files after lead creation
            dispatch(setCreatedProject([data]))
            setTimeout(() => {
                dispatch(goNext());
            }, 1000);
            setClientName("");
            setLeadDate("");
            setClientPhone("");
            setClientContactName("");
            setStatus("");
            setClientEmail("");
            setProjectName("");
            setQuotedValue("");
            setSelectedServices([]);
            setAssignedGroup("");
            setSelectedGroupId("");
            setLeadType("");
            setFollowupDate("");
            setProbability("");
            setSource("");
            setReference("");
            setComments("");
            dispatch(fetchLeads());
            SetAssignedPeople([]);
            setFileNames([]);
            setSelectedCategory("");
        } catch (error) {
            console.error("Error:", error);
            let errorMessage =
                error?.error || // For rejectWithValue
                error?.response?.data?.error || // Fallback for direct axios
                error?.message ||
                "Something went wrong. Please try again.";

            // REFACTORED: Handle duplicate errors - show clear message based on error type
            if (
                errorMessage.includes("exact Project Name, Client Name, and Group combination already exists") ||
                errorMessage === "A lead with this exact Project Name, Client Name, and Group combination already exists. Please use a different Group if you want to create a duplicate Project Name and Client Name."
            ) {
                // This is the correct validation - exact duplicate (all three match)
                errorMessage = "A lead with this exact Project Name, Client Name, and Group combination already exists. Please use a different Group to create a duplicate Project Name and Client Name.";
            } else if (
                errorMessage?.toLowerCase().includes("project name") && 
                (errorMessage?.toLowerCase().includes("already exist") || 
                 errorMessage?.toLowerCase().includes("duplicate") ||
                 errorMessage?.includes("E11000")) // MongoDB duplicate key error code
            ) {
                // This indicates MongoDB unique index is still blocking - needs to be removed
                errorMessage = "Project name already exists. The database index needs to be removed. Please run: cd Backend && node forceRemoveIndex.js, then restart the backend server.";
            }

            enqueueSnackbar(errorMessage, {
                variant: "error",
            });
        } finally {
            SetisLoading(false);
        }
    };

    const EditSubmit = async () => {

        if (
            !ClientName ||
            !LeadType ||
            (Status !== "Won" && Status !== "Lost" && !FollowupDate) ||
            (Status === "Pending" &&
                !["High", "Medium", "Low"].includes(Probability)) ||
            !LeadDate ||
            !Source ||
            !ClientPhone ||
            !ClientContactName ||
            !TypeService ||
            !Status ||
            !ProjectName ||
            !QuotedValue
        ) {
            enqueueSnackbar("Please fill all the fields!", { variant: "error" });
            return;
        }

        if (!emailRegex.test(ClientEmail)) {
            enqueueSnackbar("Please enter a valid email address!", {
                variant: "error",
            });
            return;
        }

        if (Status === "Pending" && !Probability) {
            enqueueSnackbar("Please provide Probability for Pending status!", {
                variant: "error",
            });
            return;
        }

        if (Source === "Reference" && !Reference) {
            enqueueSnackbar("Please enter Reference!", { variant: "error" });
            return;
        }

        SetisLoading(true);

        try {
            const updatedLeadData = {
                LeadOwner,
                ClientName,
                ProjectName,
                LeadDate,
                QuotedValue,
                Status,
                AssignedGroup,
                groupid: selectedGroupId || undefined,
                LeadType,
                FollowupDate,
                Probability: Status === "Pending" ? Probability : "",
                Source,
                Reference,
                TypeService,
                ClientContactName,
                ClientEmail,
                ClientPhone,
                comments,
                Category,
                quotationId,
            };
            const response = await dispatch(
                updateLead({ id: createdProject?.[0]?.id, updatedData: updatedLeadData })
            ).unwrap();

            const isErpPackage = profiles?.[0]?.subscriptionpackage === "ERP";
            const prevStatusNorm = String(createdProject?.[0]?.Status ?? "").trim().toLowerCase();
            const nextStatusTrimmed = String(Status ?? "").trim();
            const shouldLockQuoted =
                isErpPackage &&
                prevStatusNorm === "pending" &&
                (nextStatusTrimmed === "Won" || nextStatusTrimmed === "Won Recurring") &&
                quotationId;

            if (shouldLockQuoted) {
                let expensesList = otherExpenses;
                if (!expensesList?.length) {
                    try {
                        expensesList = await dispatch(fetchOtherExpenses()).unwrap();
                    } catch {
                        expensesList = [];
                    }
                }
                const salesUserId = getLoggedSalesUserId(
                    loggedInUserId,
                    employeeslist,
                    email
                );
                const expensesForUser = scopeOtherExpensesForUser(expensesList, {
                    loggedUserId: salesUserId,
                });
                const { perdiem, averagecost } =
                    getPerdiemAndAverageCostFromExpenses(expensesForUser);
                let ratesList = salesHourlyRateData;
                if (!ratesList?.length) {
                    try {
                        ratesList = await dispatch(fetchSalesHourlyRates()).unwrap();
                    } catch {
                        ratesList = [];
                    }
                }
                const projectsDetails = buildProjectsDetailsPayloadForLeadEdit(
                    projects,
                    ratesList,
                    quotationId,
                    ProjectName,
                    { perdiem, avgcost: averagecost },
                    salesUserId
                );
                if (projectsDetails.length > 0) {
                    try {
                        await dispatch(updateProjectQuotedStatusThunk(projectsDetails)).unwrap();
                        await dispatch(fetchAllProjects());
                    } catch (lockErr) {
                        console.error("Failed to update project quoted status:", lockErr);
                    }
                }
            }

            dispatch(setCreatedProject([response?.lead]))
            dispatch(fetchLeads());
        } catch (error) {
            console.error("Error:", error);
            const errorMessage =
                error?.error ||
                error?.response?.data?.error ||
                error?.message ||
                "Something went wrong!";
            enqueueSnackbar(errorMessage, { variant: "error" });
        } finally {
            SetisLoading(false);
            dispatch(setcurrentLeadID());
        }
    };

    const handleFileUpload = async (id) => {
        if (!fileNames.length) {
            return;
        }

        const uploadDate = new Date().toISOString().slice(0, 10); // "2024-07-11"
        const formData = new FormData();

        // Append the common fields
        formData.append("leadId", id);
        formData.append("uploadDate", uploadDate);

        // Append each category and file separately
        fileNames.forEach((file) => {
            formData.append("selectedCategory", file.selectedCategory);
            formData.append("files", file);
        });

        try {
            await dispatch(uploadFile(formData)).unwrap(); // Use Redux thunk
        } catch (error) {
            enqueueSnackbar("Error occurred while uploading file", {
                variant: "error",
            });
            console.error("Error uploading file:", error);
        }
    };

    return (
        <div className=" bg-[#f3f8f8] h-full">
            {isLoading ? (
                <AdminLoader isLoading={isLoading} />
            ) : (
                <>

                    <div
                        ref={leadIdDeleteRef}
                        className="relative justify-center top-2 bg-white">
                        <div className="pt-3">
                            <div className="rounded-md p-2 ">

                                <div>
                                    <div
                                        className="grid grid-cols-1 md:grid-cols-4 gap-4  "
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        <div className="pt-1  mb-4" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="date">
                                                Lead Date
                                                <span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <DatePicker
                                                wrapperClassName="w-full"
                                                selected={LeadDate}
                                                dateFormat={getDateFormat()}
                                                placeholderText={getDatePlaceholder()}
                                                maxDate={new Date()}
                                                showPopperArrow={false}
                                                onChange={(date) => {
                                                    if (!(date instanceof Date) || isNaN(date)) return;
                                                    if (date > new Date()) {
                                                        enqueueSnackbar("Future dates are not allowed", { variant: "error" });
                                                        return;
                                                    }
                                                    setLeadDate(date);
                                                }}
                                                onBlur={(e) => {
                                                    const parsed = parseTypedDate(e.target.value, getDateFormat);
                                                    if (!parsed) return;

                                                    if (parsed > new Date()) {
                                                        enqueueSnackbar("Future dates are not allowed", { variant: "error" });
                                                        return;
                                                    }
                                                    setLeadDate(parsed);
                                                }}
                                                className="border w-full border-gray-400 rounded-md p-2 shadow-md outline-none"
                                            />
                                        </div>

                                        <div
                                            className="pt-1 mb-4"
                                            style={{ width: "22%", height: "4%" }}
                                        >
                                            <label className="block" htmlFor="Source">
                                                Group<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <div className="w-full ">
                                                <div
                                                    ref={dropdownRefGroup}
                                                    className="relative flex w-full  p-0 rounded-xl align-middle items-center"
                                                >
                                                    <ExpandMoreIcon
                                                        color="white"
                                                        className="absolute cursor-pointer right-0 border-r border-gray-400 m-auto bg-white"
                                                        onClick={() => setShowGroupDropdown(!showGroupDropdown)}
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={() => setShowGroupDropdown(!showGroupDropdown)}
                                                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                                                    >
                                                        {AssignedGroup ? AssignedGroup : <p>Select Group</p>}
                                                    </button>

                                                    {showGroupDropdown && (
                                                        <div
                                                            style={{ zIndex: 9999 }}
                                                            className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                                        >
                                                            {[...GroupNames]
                                                                .sort((a, b) => a.newGroupName.localeCompare(b.newGroupName))
                                                                .map((group) => (
                                                                    <div
                                                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                                                        onClick={() => {
                                                                            handleGroupChange(group.newGroupName);
                                                                            setSelectedServiceTypes(group.servicetype);
                                                                            setSelectedServices([]);
                                                                        }}
                                                                        key={group.id}
                                                                        value={group.newGroupName}
                                                                    >
                                                                        {group.newGroupName}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="pt-1  mb-4" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="Name">
                                                Client Name<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <input
                                                className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                                                type="text"
                                                maxLength={30}
                                                placeholder="Enter Name"
                                                value={ClientName}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    const filteredValue = value.replace(
                                                        /[^a-zA-Z0-9!@#$%*_\s-]/g,
                                                        ""
                                                    );
                                                    setClientName(filteredValue);
                                                }}
                                            />
                                        </div>

                                        {/* Project Name */}
                                        <div
                                            ref={projectNameRef}   // ✅ ADD THI
                                            className="pt-1 mb-4"
                                            style={{ width: "22%", height: "4%" }}
                                        >
                                            <label className="block" htmlFor="Name">
                                                Project Name<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <input
                                                className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                                                type="text"
                                                maxLength={30}
                                                placeholder="Enter Project Name"
                                                value={ProjectName}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    const filteredValue = value.replace(
                                                        /[^a-zA-Z0-9!@#$%*_\s-]/g,
                                                        ""
                                                    );
                                                    setProjectName(filteredValue);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="grid grid-cols-1 md:grid-cols-4 gap-4 "
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        <div
                                            className=" mb-4"
                                            style={{ width: "22%", height: "4%" }}
                                        >
                                            <label className="block" htmlFor="Source">
                                                Type of Service
                                                <span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <div className=" bg-white">
                                                <div
                                                    ref={dropdownRefService}
                                                    className="relative flex  p-0  rounded-xl align-middle items-center"
                                                >
                                                    <ExpandMoreIcon
                                                        color="white"
                                                        className="absolute cursor-pointer right-2 m-auto bg-white"
                                                        onClick={() =>
                                                            setShowServiceDropdown(!showServiceDropdown)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setShowServiceDropdown(!showServiceDropdown)
                                                        }
                                                        disabled={selectedServiceTypes?.length === 0}
                                                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none"
                                                    >
                                                        {selectedServiceTypes?.length === 0 ? (
                                                            <span className="text-black">
                                                                No Service Type
                                                            </span>
                                                        ) : TypeService?.length > 0 ? (
                                                            <div className="flex overflow-hidden gap-1">
                                                                {TypeService.map((service) => (
                                                                    <span
                                                                        key={service}
                                                                        className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs"
                                                                    >
                                                                        {service}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <span className="">Select Service Type</span>
                                                        )}
                                                    </button>

                                                    {showServiceDropdown && (
                                                        <div
                                                            style={{ zIndex: 9999 }}
                                                            className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                                        >
                                                            {selectedServiceTypes.map((serviceType) => {
                                                                const isSelected =
                                                                    TypeService.includes(serviceType);
                                                                return (
                                                                    <div
                                                                        key={serviceType}
                                                                        className={`p-1 cursor-pointer ${isSelected
                                                                            ? "bg-blue-100 font-semibold"
                                                                            : "hover:bg-gray-200"
                                                                            }`}
                                                                        onClick={() => handleServiceChange(serviceType)}
                                                                    >
                                                                        {serviceType}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className=" mb-4"
                                            style={{ width: "22%", height: "4%" }}
                                        >
                                            <label className="block" htmlFor="Name">
                                                Quoted Value<span className="text-red-700 text-xl">*</span> ( {currency} )
                                            </label>
                                            <input
                                                className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                                                type="text"
                                                placeholder="Enter Quoted Value"
                                                inputMode="numeric"
                                                maxLength={14}
                                                pattern="[0-9]*"
                                                value={USAComma(QuotedValue)}
                                                onChange={(e) =>
                                                    setQuotedValue(
                                                        e.target.value.split(".")[0].replace(/,/g, "").replace(/\D/g, "")
                                                    )
                                                }
                                            />
                                        </div>

                                        <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="Source">
                                                Source<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <div className=" bg-white">
                                                <div
                                                    ref={dropdownRefSource}
                                                    className="relative flex  p-0  rounded-xl align-middle items-center"
                                                >
                                                    <ExpandMoreIcon
                                                        color="white"
                                                        className="absolute cursor-pointer right-2 m-auto"
                                                        onClick={() =>
                                                            setShowSourceDropdown(!showSourceDropdown)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setShowSourceDropdown(!showSourceDropdown)
                                                        }
                                                        className="border w-full bg-white border-gray-400 rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                                                    >
                                                        {Source ? Source : <p>Select Source</p>}
                                                    </button>

                                                    {showSourceDropdown && (
                                                        <div
                                                            style={{ zIndex: 9999 }}
                                                            className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                                        >
                                                            {[...Sources]
                                                                .sort((a, b) => a.newSource.localeCompare(b.newSource))
                                                                .map((Sourc) => (
                                                                    <div
                                                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                                                        onClick={() =>
                                                                            handleSourceChange(Sourc.newSource)
                                                                        }
                                                                        key={Sourc.id}
                                                                        value={Sourc.newSource}
                                                                    >
                                                                        {Sourc.newSource}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Reference */}
                                        <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="Name">
                                                Reference
                                                {Source === "Reference" ? (
                                                    <span className="text-red-700 text-xl">*</span>
                                                ) : (
                                                    <span className="text-red-700 text-xl"></span>
                                                )}
                                            </label>
                                            <input
                                                className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${Source !== "Reference" ? "bg-gray-200" : ""
                                                    }`}
                                                type="text"
                                                placeholder="Enter Reference"
                                                maxLength={30}
                                                value={Source === "Reference" ? Reference : ""}
                                                onChange={(e) => {
                                                    let value = e.target.value?.replace(/[^a-zA-Z\s]/g, ""); // Allows only letters and spaces
                                                    value = value?.charAt(0)?.toUpperCase() + value.slice(1); // Capitalizes the first letter
                                                    setReference(value);
                                                }}
                                                disabled={Source !== "Reference"}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="grid grid-cols-1 md:grid-cols-4 gap-4 "
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        {/* Contact Person */}
                                        <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="Name">
                                                Contact Person
                                                <span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <input
                                                className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                                                type="text"
                                                maxLength={30}
                                                placeholder="Enter Name"
                                                value={ClientContactName}
                                                onChange={(e) => {
                                                    let value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allows only letters and spaces
                                                    value = value?.charAt(0)?.toUpperCase() + value.slice(1); // Capitalizes the first letter
                                                    setClientContactName(value);
                                                }}
                                            />
                                        </div>

                                        {/* Email ID */}
                                        <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="email">
                                                Email ID<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <input
                                                className="border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                                                type="text"
                                                placeholder="Enter Email ID"
                                                value={ClientEmail}
                                                onChange={(e) => setClientEmail(e.target.value)}
                                            />
                                        </div>

                                        {/* Mobile Number */}
                                        <div className="mb-4" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="Name">
                                                Mobile Number<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            {console.log("wizard1 Phone state:", ClientPhone)}

                                            {defaultCountry && (
                                                <PhoneInput
                                                    // country="in"
                                                    country={defaultCountry}
                                                    countryCodeEditable={false}
                                                    disableDropdown
                                                    value={ClientPhone}
                                                    onChange={(value) => setClientPhone(value)}
                                                    inputProps={{
                                                        required: true,
                                                        className:
                                                            "w-full h-10 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-10",
                                                        style: {
                                                            fontFamily:
                                                                "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                                                        },
                                                    }}
                                                />)}

                                            {/* <PhoneInput
                                                country={defaultCountry}
                                                disableDropdown={true}
                                                disableCountryGuess={true}
                                                countryCodeEditable={false}
                                                value={ClientPhone}
                                                onChange={(value, country) => {
                                                    setClientPhone(value);
                                                }}
                                                onlyCountries={allowedCountries}
                                                preferredCountries={[]}
                                                enableSearch={true}
                                                inputProps={{
                                                    required: true,
                                                    className:
                                                        "w-full h-10 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-10",
                                                    style: {
                                                        fontFamily:
                                                            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                                                    },
                                                }}
                                            /> */}
                                        </div>

                                        {/* Lead Type */}
                                        <div
                                            className="mb-4"
                                            style={{ width: "22%", height: "4%" }}
                                        >
                                            <label className="block" htmlFor="Source">
                                                Lead Type<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <div className=" bg-white">
                                                <div
                                                    ref={dropdownRefLeadType}
                                                    className="relative flex  p-0  rounded-xl align-middle items-center"
                                                >
                                                    <ExpandMoreIcon
                                                        color="white"
                                                        className="absolute cursor-pointer right-2 m-auto bg-white"
                                                        onClick={() =>
                                                            setShowLeadTypeDropdown(!showLeadTypeDropdown)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setShowLeadTypeDropdown(!showLeadTypeDropdown)
                                                        }
                                                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                                                    >
                                                        {LeadType ? LeadType : <p>Select Lead Type</p>}
                                                    </button>

                                                    {showLeadTypeDropdown && (
                                                        <div
                                                            style={{ zIndex: 9999 }}
                                                            className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                                        >
                                                            {LeadTypes.map((LeadTyp) => (
                                                                <div
                                                                    className="p-1 hover:bg-gray-200 cursor-pointer"
                                                                    onClick={() =>
                                                                        handleLeadTypeChange(LeadTyp.LeadType)
                                                                    }
                                                                    key={LeadTyp.id}
                                                                    value={LeadTyp.LeadType}
                                                                >
                                                                    {LeadTyp.LeadType}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="grid grid-cols-1 md:grid-cols-4 gap-4"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        {/* Status */}
                                        <div className="pt-1" style={{ width: "22%", height: "4%" }}>
                                            <label className="block" htmlFor="Status">
                                                Status<span className="text-red-700 text-xl">*</span>
                                            </label>
                                            <div className=" bg-white">
                                                <div
                                                    ref={dropdownRefStatus}
                                                    className="relative flex  p-0  rounded-xl align-middle items-center"
                                                >
                                                    <ExpandMoreIcon
                                                        color="white"
                                                        className="absolute cursor-pointer right-2 m-auto bg-white"
                                                        onClick={() =>
                                                            setShowStatusDropdown(!showStatusDropdown)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            setShowStatusDropdown(!showStatusDropdown)
                                                        }
                                                        className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none"
                                                    >
                                                        {Status ? Status : <p>Select Status</p>}
                                                    </button>

                                                    {showStatusDropdown && (
                                                        <div
                                                            style={{ zIndex: 9999 }}
                                                            className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                                        >
                                                            {statuses.map((statuse) => (
                                                                <div
                                                                    className="p-1 hover:bg-gray-200 cursor-pointer"
                                                                    onClick={() => handleStatusChange(statuse.status)}
                                                                    key={statuse.id}
                                                                    value={statuse.status}
                                                                >
                                                                    {statuse.status}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Probability */}
                                        <div className="pt-1" style={{ width: "22%", height: "4%" }}>
                                            {Status !== "Won" && Status !== "Lost" && (
                                                <>
                                                    <label className="block" htmlFor="Status">
                                                        Probability{" "}
                                                        {Status === "Pending" ? (
                                                            <span className="text-red-700 text-xl">*</span>
                                                        ) : (
                                                            <span className="text-red-700 text-xl"></span>
                                                        )}
                                                    </label>
                                                    <div className=" bg-white">
                                                        <div
                                                            ref={dropdownRefProbability}
                                                            className="relative flex  p-0  rounded-xl align-middle items-center"
                                                        >
                                                            <ExpandMoreIcon
                                                                onClick={() =>
                                                                    setShowProbabilityDropdown(!showProbabilityDropdown)
                                                                }
                                                                color="white"
                                                                className="absolute cursor-pointer right-2 m-auto "
                                                            />

                                                            <button
                                                                type="button"
                                                                onClick={() =>
                                                                    setShowProbabilityDropdown(!showProbabilityDropdown)
                                                                }
                                                                disabled={Status !== "Pending"} // Disable when Status is not "Pending"
                                                                className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden  outline-none ${Status !== "Pending" ? "bg-gray-200" : ""
                                                                    }`}
                                                            >
                                                                {Probability ? Probability : <p>Select Probability</p>}
                                                            </button>

                                                            {showProbabilityDropdown && (
                                                                <div
                                                                    style={{ zIndex: 9999 }}
                                                                    className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                                                >
                                                                    <div
                                                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                                                        onClick={() => handleProbabilityChange("High")}
                                                                    >
                                                                        High
                                                                    </div>
                                                                    <div
                                                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                                                        onClick={() => handleProbabilityChange("Medium")}
                                                                    >
                                                                        Medium
                                                                    </div>
                                                                    <div
                                                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                                                        onClick={() => handleProbabilityChange("Low")}
                                                                    >
                                                                        Low
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* Next Follow-up Date */}
                                        <div className="pt-1" style={{ width: "22.5%", height: "4%" }}>
                                            <label className="block" htmlFor="date">
                                                {Status === "Won" || Status === "Lost" ? (
                                                    ""
                                                ) : (
                                                    <>
                                                        Next Follow-up Date{" "}
                                                        <span className="text-red-700 text-xl">*</span>
                                                    </>
                                                )}
                                            </label>

                                            {Status !== "Won" && Status !== "Lost" && (
                                                <DatePicker
                                                    selected={FollowupDate}
                                                    onChange={(date) => setFollowupDate(date)}
                                                    dateFormat={getDateFormat()}
                                                    placeholderText={getDatePlaceholder()}
                                                    minDate={
                                                        LeadDate
                                                            ? new Date(
                                                                new Date(LeadDate).setDate(
                                                                    new Date(LeadDate).getDate() + 1
                                                                )
                                                            )
                                                            : null
                                                    }
                                                    customInput={
                                                        <InputMask
                                                            mask={getDateFormat().includes("/") ? "99/99/9999" : "99-99-9999"}
                                                            placeholder={getDatePlaceholder()}
                                                            className="border w-full pr-16 border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                                                        />
                                                    }
                                                    onChangeRaw={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (!inputValue || inputValue?.length < 10) return;
                                                        const parsedDate = parseTypedDate(inputValue, getDateFormat());
                                                        if (!parsedDate || isNaN(parsedDate.getTime())) return;
                                                        setFollowupDate(parsedDate);
                                                    }}
                                                />
                                            )}
                                        </div>

                                        <div className="pt-1.5 flex gap-2" style={{ width: "22%", height: "4%" }}>
                                            <FileUploadAddLead
                                                setFileNames={setFileNames}
                                                fileNames={fileNames}
                                                SelectedCategory={SelectedCategory}
                                                setSelectedCategory={setSelectedCategory}
                                                projectName={ProjectName}
                                            />
                                        </div>
                                    </div>
                                    <br></br>

                                    {/* Comments */}
                                    <div className="w-full flex">
                                        <div className="w-1/2 pr-5">
                                            <label className="block" htmlFor="comments">
                                                Comments
                                            </label>
                                            <textarea
                                                className="border w-full border-gray-400 rounded-md p-4 overflow-hidden shadow-md outline-none resize-none"
                                                placeholder="Enter Comments"
                                                id="comments"
                                                value={comments}
                                                onChange={(e) => setComments(e.target.value)}
                                                required={Status === "Pending"}
                                                name="comments"
                                                rows={2}
                                            />
                                        </div>

                                        <div className="w-1/2 flex justify-end items-end pb-1">
                                            {Status === "Lost" ? (
                                                <div className="h-10 flex items-end gap-4">
                                                    <button
                                                        className={`${step === 1 ? "bg-gray-400 text-white cursor-default" : "bg-black text-white cursor-pointer"} py-2 px-7  overflow-hidden shadow-md  rounded-lg `}
                                                    >
                                                        Back
                                                    </button>

                                                    <button
                                                        onClick={() => {
                                                            Submit()
                                                            setTimeout(() => {
                                                                navigate("/dashboard/leadreport")
                                                            }, 1500);
                                                        }}
                                                        className={`${isValid ? "bg-[#e32278] cursor-pointer" : "bg-[#e8c0d2] cursor-default"}  py-2 px-7  overflow-hidden shadow-md text-black rounded-lg `}
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="h-10 flex items-end gap-4">
                                                    <button
                                                        onClick={() => {
                                                            if (step === 1) {
                                                                navigate('/dashboard');
                                                                dispatch(setShowWizard(true));
                                                                dispatch(resetcurrentLeadID())
                                                            }
                                                        }}
                                                        className={`bg-black text-white cursor-pointer py-2 px-7  overflow-hidden shadow-md  rounded-lg `}
                                                    >
                                                        Back
                                                    </button>
                                                    {createdProject?.length > 0 ? (
                                                        hasForwardedManagers ? (
                                                            <button
                                                                onClick={() => {
                                                                    // Navigate to step 2 without submitting again
                                                                    dispatch(goNext());
                                                                }}
                                                                className="bg-[#e32278] cursor-pointer text-white py-2 px-7 overflow-hidden shadow-md rounded-lg"
                                                            >
                                                                Next
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={() => {
                                                                    EditSubmit()
                                                                    setTimeout(() => {
                                                                        dispatch(goNext());
                                                                    }, 1000);
                                                                }}
                                                                disabled={!isValid}
                                                                className={`${isValid ?
                                                                    "bg-[#e32278] cursor-pointer text-white" :
                                                                    "bg-[#e8c0d2] cursor-not-allowed text-black"}  
      py-2 px-7 overflow-hidden shadow-md  rounded-lg`}
                                                            >
                                                                Submit
                                                            </button>
                                                        )
                                                    ) : (

                                                        <button
                                                            onClick={() => {
                                                                Submit()
                                                            }}
                                                            disabled={!isValid}
                                                            className={`${isValid ?
                                                                "bg-[#e32278] cursor-pointer text-white" :
                                                                "bg-[#e8c0d2] cursor-not-allowed text-black"}  
      py-2 px-7 overflow-hidden shadow-md  rounded-lg`}
                                                        >
                                                            Submit
                                                        </button>
                                                    )}



                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </>
            )}
        </div>
    );
};

export default AddProject;
